import React, { useState, useEffect } from 'react';
import { 
  UserGroupIcon, 
  ShieldCheckIcon, 
  PlusIcon, 
  MagnifyingGlassIcon,
  FunnelIcon,
  EyeIcon,
  PencilIcon,
  TrashIcon,
  KeyIcon,
  UserIcon,
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import API_CONFIG from '../config/api';
import { getComuniByProvincia, searchComuni, getDefaultComuni } from '../utils/comuni';
import LicenseStatusWidget from '../components/network/LicenseStatusWidget';

// Dati delle province italiane
const PROVINCE_ITALIANE = [
  { codice: '001', nome: 'Torino', sigla: 'TO', regione: 'Piemonte' },
  { codice: '002', nome: 'Vercelli', sigla: 'VC', regione: 'Piemonte' },
  { codice: '003', nome: 'Novara', sigla: 'NO', regione: 'Piemonte' },
  { codice: '004', nome: 'Cuneo', sigla: 'CN', regione: 'Piemonte' },
  { codice: '005', nome: 'Asti', sigla: 'AT', regione: 'Piemonte' },
  { codice: '006', nome: 'Alessandria', sigla: 'AL', regione: 'Piemonte' },
  { codice: '007', nome: 'Valle d\'Aosta', sigla: 'AO', regione: 'Valle d\'Aosta' },
  { codice: '008', nome: 'Imperia', sigla: 'IM', regione: 'Liguria' },
  { codice: '009', nome: 'Savona', sigla: 'SV', regione: 'Liguria' },
  { codice: '010', nome: 'Genova', sigla: 'GE', regione: 'Liguria' },
  { codice: '011', nome: 'La Spezia', sigla: 'SP', regione: 'Liguria' },
  { codice: '012', nome: 'Varese', sigla: 'VA', regione: 'Lombardia' },
  { codice: '013', nome: 'Como', sigla: 'CO', regione: 'Lombardia' },
  { codice: '014', nome: 'Sondrio', sigla: 'SO', regione: 'Lombardia' },
  { codice: '015', nome: 'Milano', sigla: 'MI', regione: 'Lombardia' },
  { codice: '016', nome: 'Bergamo', sigla: 'BG', regione: 'Lombardia' },
  { codice: '017', nome: 'Brescia', sigla: 'BS', regione: 'Lombardia' },
  { codice: '018', nome: 'Pavia', sigla: 'PV', regione: 'Lombardia' },
  { codice: '019', nome: 'Cremona', sigla: 'CR', regione: 'Lombardia' },
  { codice: '020', nome: 'Mantova', sigla: 'MN', regione: 'Lombardia' },
  { codice: '021', nome: 'Bolzano', sigla: 'BZ', regione: 'Trentino Alto Adige' },
  { codice: '022', nome: 'Trento', sigla: 'TN', regione: 'Trentino Alto Adige' },
  { codice: '023', nome: 'Verona', sigla: 'VR', regione: 'Veneto' },
  { codice: '024', nome: 'Vicenza', sigla: 'VI', regione: 'Veneto' },
  { codice: '025', nome: 'Belluno', sigla: 'BL', regione: 'Veneto' },
  { codice: '026', nome: 'Treviso', sigla: 'TV', regione: 'Veneto' },
  { codice: '027', nome: 'Venezia', sigla: 'VE', regione: 'Veneto' },
  { codice: '028', nome: 'Padova', sigla: 'PD', regione: 'Veneto' },
  { codice: '029', nome: 'Rovigo', sigla: 'RO', regione: 'Veneto' },
  { codice: '030', nome: 'Udine', sigla: 'UD', regione: 'Friuli Venezia Giulia' },
  { codice: '031', nome: 'Gorizia', sigla: 'GO', regione: 'Friuli Venezia Giulia' },
  { codice: '032', nome: 'Trieste', sigla: 'TS', regione: 'Friuli Venezia Giulia' },
  { codice: '033', nome: 'Piacenza', sigla: 'PC', regione: 'Emilia Romagna' },
  { codice: '034', nome: 'Parma', sigla: 'PR', regione: 'Emilia Romagna' },
  { codice: '035', nome: 'Reggio nell\'Emilia', sigla: 'RE', regione: 'Emilia Romagna' },
  { codice: '036', nome: 'Modena', sigla: 'MO', regione: 'Emilia Romagna' },
  { codice: '037', nome: 'Bologna', sigla: 'BO', regione: 'Emilia Romagna' },
  { codice: '038', nome: 'Ferrara', sigla: 'FE', regione: 'Emilia Romagna' },
  { codice: '039', nome: 'Ravenna', sigla: 'RA', regione: 'Emilia Romagna' },
  { codice: '040', nome: 'Forlì-Cesena', sigla: 'FC', regione: 'Emilia Romagna' },
  { codice: '041', nome: 'Pesaro e Urbino', sigla: 'PU', regione: 'Marche' },
  { codice: '042', nome: 'Ancona', sigla: 'AN', regione: 'Marche' },
  { codice: '043', nome: 'Macerata', sigla: 'MC', regione: 'Marche' },
  { codice: '044', nome: 'Ascoli Piceno', sigla: 'AP', regione: 'Marche' },
  { codice: '045', nome: 'Massa-Carrara', sigla: 'MS', regione: 'Toscana' },
  { codice: '046', nome: 'Lucca', sigla: 'LU', regione: 'Toscana' },
  { codice: '047', nome: 'Pistoia', sigla: 'PT', regione: 'Toscana' },
  { codice: '048', nome: 'Firenze', sigla: 'FI', regione: 'Toscana' },
  { codice: '049', nome: 'Livorno', sigla: 'LI', regione: 'Toscana' },
  { codice: '050', nome: 'Pisa', sigla: 'PI', regione: 'Toscana' },
  { codice: '051', nome: 'Arezzo', sigla: 'AR', regione: 'Toscana' },
  { codice: '052', nome: 'Siena', sigla: 'SI', regione: 'Toscana' },
  { codice: '053', nome: 'Grosseto', sigla: 'GR', regione: 'Toscana' },
  { codice: '054', nome: 'Perugia', sigla: 'PG', regione: 'Umbria' },
  { codice: '055', nome: 'Terni', sigla: 'TR', regione: 'Umbria' },
  { codice: '056', nome: 'Viterbo', sigla: 'VT', regione: 'Lazio' },
  { codice: '057', nome: 'Rieti', sigla: 'RI', regione: 'Lazio' },
  { codice: '058', nome: 'Roma', sigla: 'RM', regione: 'Lazio' },
  { codice: '059', nome: 'Latina', sigla: 'LT', regione: 'Lazio' },
  { codice: '060', nome: 'Frosinone', sigla: 'FR', regione: 'Lazio' },
  { codice: '061', nome: 'Caserta', sigla: 'CE', regione: 'Campania' },
  { codice: '062', nome: 'Benevento', sigla: 'BN', regione: 'Campania' },
  { codice: '063', nome: 'Napoli', sigla: 'NA', regione: 'Campania' },
  { codice: '064', nome: 'Avellino', sigla: 'AV', regione: 'Campania' },
  { codice: '065', nome: 'Salerno', sigla: 'SA', regione: 'Campania' },
  { codice: '066', nome: 'L\'Aquila', sigla: 'AQ', regione: 'Abruzzo' },
  { codice: '067', nome: 'Teramo', sigla: 'TE', regione: 'Abruzzo' },
  { codice: '068', nome: 'Pescara', sigla: 'PE', regione: 'Abruzzo' },
  { codice: '069', nome: 'Chieti', sigla: 'CH', regione: 'Abruzzo' },
  { codice: '070', nome: 'Campobasso', sigla: 'CB', regione: 'Molise' },
  { codice: '071', nome: 'Foggia', sigla: 'FG', regione: 'Puglia' },
  { codice: '072', nome: 'Bari', sigla: 'BA', regione: 'Puglia' },
  { codice: '073', nome: 'Taranto', sigla: 'TA', regione: 'Puglia' },
  { codice: '074', nome: 'Brindisi', sigla: 'BR', regione: 'Puglia' },
  { codice: '075', nome: 'Lecce', sigla: 'LE', regione: 'Puglia' },
  { codice: '076', nome: 'Potenza', sigla: 'PZ', regione: 'Basilicata' },
  { codice: '077', nome: 'Matera', sigla: 'MT', regione: 'Basilicata' },
  { codice: '078', nome: 'Cosenza', sigla: 'CS', regione: 'Calabria' },
  { codice: '079', nome: 'Catanzaro', sigla: 'CZ', regione: 'Calabria' },
  { codice: '080', nome: 'Reggio Calabria', sigla: 'RC', regione: 'Calabria' },
  { codice: '081', nome: 'Trapani', sigla: 'TP', regione: 'Sicilia' },
  { codice: '082', nome: 'Palermo', sigla: 'PA', regione: 'Sicilia' },
  { codice: '083', nome: 'Messina', sigla: 'ME', regione: 'Sicilia' },
  { codice: '084', nome: 'Agrigento', sigla: 'AG', regione: 'Sicilia' },
  { codice: '085', nome: 'Caltanissetta', sigla: 'CL', regione: 'Sicilia' },
  { codice: '086', nome: 'Enna', sigla: 'EN', regione: 'Sicilia' },
  { codice: '087', nome: 'Catania', sigla: 'CT', regione: 'Sicilia' },
  { codice: '088', nome: 'Ragusa', sigla: 'RG', regione: 'Sicilia' },
  { codice: '089', nome: 'Siracusa', sigla: 'SR', regione: 'Sicilia' },
  { codice: '090', nome: 'Sassari', sigla: 'SS', regione: 'Sardegna' },
  { codice: '091', nome: 'Nuoro', sigla: 'NU', regione: 'Sardegna' },
  { codice: '092', nome: 'Cagliari', sigla: 'CA', regione: 'Sardegna' },
  { codice: '093', nome: 'Pordenone', sigla: 'PN', regione: 'Friuli Venezia Giulia' },
  { codice: '094', nome: 'Isernia', sigla: 'IS', regione: 'Molise' },
  { codice: '095', nome: 'Oristano', sigla: 'OR', regione: 'Sardegna' },
  { codice: '096', nome: 'Biella', sigla: 'BI', regione: 'Piemonte' },
  { codice: '097', nome: 'Lecco', sigla: 'LC', regione: 'Lombardia' },
  { codice: '098', nome: 'Lodi', sigla: 'LO', regione: 'Lombardia' },
  { codice: '099', nome: 'Rimini', sigla: 'RN', regione: 'Emilia Romagna' },
  { codice: '100', nome: 'Prato', sigla: 'PO', regione: 'Toscana' },
  { codice: '101', nome: 'Crotone', sigla: 'KR', regione: 'Calabria' },
  { codice: '102', nome: 'Vibo Valentia', sigla: 'VV', regione: 'Calabria' },
  { codice: '103', nome: 'Verbano-Cusio-Ossola', sigla: 'VB', regione: 'Piemonte' },
  { codice: '108', nome: 'Monza e della Brianza', sigla: 'MB', regione: 'Lombardia' },
  { codice: '109', nome: 'Fermo', sigla: 'FM', regione: 'Marche' },
  { codice: '110', nome: 'Barletta-Andria-Trani', sigla: 'BT', regione: 'Puglia' },
  { codice: '111', nome: 'Sud Sardegna', sigla: 'SU', regione: 'Sardegna' }
];

const GestioneUtentiPage = () => {
  // Recupera utente corrente da localStorage
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user'));
  } catch (e) {
    user = null;
  }
  
  const [activeTab, setActiveTab] = useState('rete');
  const [utentiRete, setUtentiRete] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [statistiche, setStatistiche] = useState(null);
  const [ruoliDisponibili, setRuoliDisponibili] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Filtri e ricerca
  const [searchTerm, setSearchTerm] = useState('');
  const [filtroRuolo, setFiltroRuolo] = useState('');
  const [filtroAttivo, setFiltroAttivo] = useState('');
  const [paginazione, setPaginazione] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0
  });

  // Modali
  const [showUserModal, setShowUserModal] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalMode, setModalMode] = useState('create');

  const [controlloStatiInCorso, setControlloStatiInCorso] = useState(false);

  // Carica dati iniziali
  useEffect(() => {
    const inizializza = async () => {
      setLoading(true);
      try {
        await Promise.all([
          caricaStatistiche(),
          caricaRuoli()
        ]);
        // NON caricare i dati qui per evitare duplicati - sarà fatto dal secondo useEffect
      } catch (error) {
        console.error('Errore nell\'inizializzazione:', error);
      } finally {
        setLoading(false);
      }
    };

    inizializza();
  }, []); // Dipende solo dal mount iniziale

  // Effect per il caricamento dati (cambio tab e filtri)
  useEffect(() => {
    const caricaDati = async () => {
      if (activeTab === 'rete') {
        await caricaUtentiRete();
      } else {
        await caricaAdmin();
      }
    };
    
    caricaDati();
  }, [activeTab, paginazione.page, searchTerm, filtroRuolo, filtroAttivo]);

  const caricaStatistiche = async () => {
    try {
      const response = await fetch('/api/network/utenti/statistiche', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setStatistiche(data);
      } else {
        console.error('Errore nel caricamento statistiche:', data.error);
        toast.error('Errore nel caricamento delle statistiche');
      }
    } catch (error) {
      console.error('Errore nel caricamento statistiche:', error);
      toast.error('Errore nel caricamento delle statistiche');
    }
  };

  const caricaRuoli = async () => {
    try {
      const response = await fetch('/api/network/utenti/ruoli', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setRuoliDisponibili(data);
      } else {
        console.error('Errore nel caricamento ruoli:', data.error);
        toast.error('Errore nel caricamento dei ruoli');
      }
    } catch (error) {
      console.error('Errore nel caricamento ruoli:', error);
      toast.error('Errore nel caricamento dei ruoli');
    }
  };

  const caricaUtentiRete = async () => {
    try {
      const params = new URLSearchParams({
        page: paginazione.page,
        limit: paginazione.limit,
        ...(searchTerm && { search: searchTerm }),
        ...(filtroRuolo && { ruolo: filtroRuolo }),
        ...(filtroAttivo && { attivo: filtroAttivo })
      });

      const token = localStorage.getItem('token');
      const response = await fetch(`/api/network/utenti/rete?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setUtentiRete(data.utenti || []);
        setPaginazione(prev => ({
          ...prev,
          total: data.pagination?.total || 0,
          totalPages: data.pagination?.totalPages || 0
        }));
      } else {
        console.error('Errore nel caricamento utenti rete:', data.error);
        toast.error('Errore nel caricamento degli utenti rete');
      }

    } catch (error) {
      console.error('Errore nel caricamento utenti rete:', error);
      toast.error('Errore nel caricamento degli utenti rete');
    }
  };

  const caricaAdmin = async () => {
    try {
      const params = new URLSearchParams({
        page: paginazione.page,
        limit: paginazione.limit,
        ...(searchTerm && { search: searchTerm }),
        ...(filtroAttivo && { attivo: filtroAttivo })
      });

      const response = await fetch(`/api/network/utenti/admin?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setAdmin(data.admin || []);
        setPaginazione(prev => ({
          ...prev,
          total: data.pagination?.total || 0,
          totalPages: data.pagination?.totalPages || 0
        }));
      } else {
        console.error('Errore nel caricamento admin:', data.error);
        toast.error('Errore nel caricamento degli admin');
      }
    } catch (error) {
      console.error('Errore nel caricamento admin:', error);
      toast.error('Errore nel caricamento degli admin');
    }
  };

  const handleCreateUser = () => {
    setSelectedUser(null);
    setModalMode('create');
    if (activeTab === 'rete') {
      setShowUserModal(true);
    } else {
      setShowAdminModal(true);
    }
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setModalMode('edit');
    if (activeTab === 'rete') {
      setShowUserModal(true);
    } else {
      setShowAdminModal(true);
    }
  };

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setModalMode('view');
    if (activeTab === 'rete') {
      setShowUserModal(true);
    } else {
      setShowAdminModal(true);
    }
  };

  const handleDeleteUser = (user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  const handleResetPassword = (user) => {
    setSelectedUser(user);
    setShowPasswordModal(true);
  };

  const handleSaveUtenteRete = async (datiUtente) => {
    try {
      const token = localStorage.getItem('token');
      const url = modalMode === 'create' 
        ? '/api/network/utenti/rete'
        : `/api/network/utenti/rete/${selectedUser.id}`;
      
      const method = modalMode === 'create' ? 'POST' : 'PUT';
      
      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datiUtente)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(modalMode === 'create' ? 'Utente creato con successo' : 'Utente aggiornato con successo');
        setShowUserModal(false);
        setSelectedUser(null);
        setModalMode('create');
        // Ricarica i dati
        await Promise.all([caricaUtentiRete(), caricaStatistiche()]);
      } else {
        toast.error(data.error || 'Errore nel salvataggio');
      }
    } catch (error) {
      console.error('Errore nel salvataggio utente rete:', error);
      toast.error('Errore nel salvataggio dell\'utente');
    }
  };

  const handleSaveAdmin = async (datiAdmin) => {
    try {
      const token = localStorage.getItem('token');
      const url = modalMode === 'create' 
        ? '/api/network/utenti/admin'
        : `/api/network/utenti/admin/${selectedUser.id}`;
      
      const method = modalMode === 'create' ? 'POST' : 'PUT';
      
      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datiAdmin)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(modalMode === 'create' ? 'Admin creato con successo' : 'Admin aggiornato con successo');
        setShowAdminModal(false);
        setSelectedUser(null);
        setModalMode('create');
        // Ricarica i dati
        await Promise.all([caricaAdmin(), caricaStatistiche()]);
      } else {
        toast.error(data.error || 'Errore nel salvataggio');
      }
    } catch (error) {
      console.error('Errore nel salvataggio admin:', error);
      toast.error('Errore nel salvataggio dell\'admin');
    }
  };

  const handleResetPasswordAction = async (utenteId, nuovaPassword) => {
    try {
      const token = localStorage.getItem('token');
      const endpoint = activeTab === 'rete' 
        ? `/api/network/utenti/rete/${utenteId}/reset-password`
        : `/api/network/utenti/admin/${utenteId}/reset-password`;
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ nuovaPassword })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Password resettata con successo');
        setShowPasswordModal(false);
        setSelectedUser(null);
      } else {
        toast.error(data.error || 'Errore nel reset password');
      }
    } catch (error) {
      console.error('Errore nel reset password:', error);
      toast.error('Errore nel reset della password');
    }
  };

  const handleDeleteUtente = async (utenteId, eliminaDefinitivamente = false) => {
    try {
      const token = localStorage.getItem('token');
      const endpoint = activeTab === 'rete' 
        ? `/api/network/utenti/rete/${utenteId}`
        : `/api/network/utenti/admin/${utenteId}`;
      
      const response = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ eliminaDefinitivamente })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(eliminaDefinitivamente ? 'Utente eliminato definitivamente' : 'Utente disattivato');
        setShowDeleteModal(false);
        setSelectedUser(null);
        // Ricarica i dati
        if (activeTab === 'rete') {
          await Promise.all([caricaUtentiRete(), caricaStatistiche()]);
        } else {
          await Promise.all([caricaAdmin(), caricaStatistiche()]);
        }
      } else {
        toast.error(data.error || 'Errore nell\'eliminazione');
      }
    } catch (error) {
      console.error('Errore nell\'eliminazione utente:', error);
      toast.error('Errore nell\'eliminazione dell\'utente');
    }
  };

  // Nuove funzioni per controllo nodi rete
  const controllaStatoUtenti = async () => {
    try {
      setControlloStatiInCorso(true);
      const response = await api.post(`/network/utenti/controlla-stati`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        toast.success(`Controllo completato: ${response.data.data.utentiDisattivati} utenti disattivati, ${response.data.data.utentiOk} utenti OK`);
        caricaUtentiRete(); // Ricarica la lista utenti
      }
    } catch (error) {
      console.error('Errore nel controllo stati utenti:', error);
      toast.error('Errore nel controllo stati utenti');
    } finally {
      setControlloStatiInCorso(false);
    }
  };

  const riAttivaUtente = async (utenteId, username) => {
    try {
      const response = await api.post(`/network/utenti/${utenteId}/riattiva`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        toast.success(`Utente ${username} riattivato con successo`);
        caricaUtentiRete(); // Ricarica la lista utenti
      } else {
        toast.info(response.data.message || 'Utente non riattivato');
      }
    } catch (error) {
      console.error('Errore nella riattivazione utente:', error);
      toast.error('Errore nella riattivazione utente');
    }
  };

  const verificaStatoUtente = async (utenteId, username) => {
    try {
      const response = await api.get(`/network/utenti/${utenteId}/verifica-stato`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        const { statoNodi } = response.data.data;
        const message = statoNodi.hasNodiAttivi ? 
          `Utente ${username} ha ${statoNodi.nodiCount} nodi attivi` : 
          `Utente ${username} non ha nodi rete attivi`;
        
        toast.info(message);
      }
    } catch (error) {
      console.error('Errore nella verifica stato utente:', error);
      toast.error('Errore nella verifica stato utente');
    }
  };

  const TabellaUtenti = () => {
    const utenti = activeTab === 'rete' ? utentiRete : admin;
    
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        {/* Header risultati */}
        <div className="px-4 sm:px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div className="text-sm text-gray-600">
              Trovati <span className="font-medium text-gray-900">{paginazione.total}</span> utenti
              {searchTerm && (
                <span> per <span className="font-medium">"{searchTerm}"</span></span>
              )}
            </div>
            <div className="text-sm text-gray-500">
              Pagina {paginazione.page} di {paginazione.totalPages}
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Utente
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Ruolo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contatti
                </th>
                {activeTab === 'rete' && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nodo Rete
                  </th>
                )}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Stato
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {utenti.length === 0 ? (
                <tr>
                  <td colSpan={activeTab === 'rete' ? 6 : 5} className="px-6 py-12 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <UserGroupIcon className="h-12 w-12 text-gray-300 mb-4" />
                      <p className="text-gray-500 text-lg font-medium">Nessun utente trovato</p>
                      <p className="text-gray-400 text-sm mt-1">Prova a modificare i filtri di ricerca</p>
                    </div>
                  </td>
                </tr>
              ) : (
                utenti.map((utente) => (
                  <tr key={`${activeTab}-${utente.id}`} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-10 w-10 flex-shrink-0">
                          <div className="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center">
                            <span className="text-sm font-medium text-white">
                              {(utente.nome?.[0] || '') + (utente.cognome?.[0] || '')}
                            </span>
                          </div>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">
                            {utente.nome} {utente.cognome}
                          </div>
                          <div className="text-sm text-gray-500">
                            @{utente.username}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        utente.role === 'admin' 
                          ? 'bg-purple-100 text-purple-800'
                          : utente.role === 'agenzia'
                          ? 'bg-blue-100 text-blue-800'
                          : utente.role === 'team_leader'
                          ? 'bg-orange-100 text-orange-800'
                          : utente.role === 'segnalatore'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-green-100 text-green-800'
                      }`}>
                        {utente.role === 'admin' ? 'Amministratore' : 
                         utente.role === 'agenzia' ? 'Agenzia' : 
                         utente.role === 'team_leader' ? 'Team Leader' :
                         utente.role === 'segnalatore' ? 'Segnalatore' : 'Subagente'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <div className="space-y-1">
                        <div>{utente.email}</div>
                        {utente.telefono && (
                          <div className="text-gray-500">{utente.telefono}</div>
                        )}
                      </div>
                    </td>
                    {activeTab === 'rete' && (
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {utente.nodoRete ? (
                          <div>
                            <div className="font-medium">{utente.nodoRete.nome}</div>
                            <div className="text-gray-500 text-xs">{utente.nodoRete.tipoNodo}</div>
                          </div>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                    )}
                    <td className="px-6 py-4 whitespace-nowrap">
                      {utente.active ? (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          Attivo
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                          Inattivo
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end space-x-2">
                        {/* Bottoni specifici per utenti rete */}
                        {activeTab === 'rete' && (
                          <>
                            <button
                              onClick={() => verificaStatoUtente(utente.id, utente.username)}
                              className="text-blue-600 hover:text-blue-900 transition-colors"
                              title="Verifica stato nodi"
                            >
                              <CheckCircleIcon className="h-4 w-4" />
                            </button>
                            
                            {/* Bottone riattiva - solo per utenti inattivi */}
                            {!utente.active && (
                              <button
                                onClick={() => riAttivaUtente(utente.id, utente.username)}
                                className="text-green-600 hover:text-green-900 transition-colors"
                                title="Riattiva se ha nodi attivi"
                              >
                                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                              </button>
                            )}
                          </>
                        )}
                        
                        {/* Bottoni standard */}
                        <button
                          onClick={() => handleViewUser(utente)}
                          className="text-blue-600 hover:text-blue-900 transition-colors"
                          title="Visualizza"
                        >
                          <EyeIcon className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleEditUser(utente)}
                          className="text-indigo-600 hover:text-indigo-900 transition-colors"
                          title="Modifica"
                        >
                          <PencilIcon className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleResetPassword(utente)}
                          className="text-yellow-600 hover:text-yellow-900 transition-colors"
                          title="Reset Password"
                        >
                          <KeyIcon className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleDeleteUser(utente)}
                          className="text-red-600 hover:text-red-900 transition-colors"
                          title="Elimina"
                        >
                          <TrashIcon className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Paginazione */}
        {paginazione.totalPages > 1 && (
          <div className="px-4 sm:px-6 py-4 bg-gray-50 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-sm text-gray-700">
                Visualizzando <span className="font-medium">{((paginazione.page - 1) * paginazione.limit) + 1}</span> - <span className="font-medium">{Math.min(paginazione.page * paginazione.limit, paginazione.total)}</span> di <span className="font-medium">{paginazione.total}</span> risultati
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setPaginazione(prev => ({ ...prev, page: prev.page - 1 }))}
                  disabled={paginazione.page === 1}
                  className="p-2 rounded-md border border-gray-300 bg-white text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronLeftIcon className="h-5 w-5" />
                </button>
                
                <div className="hidden sm:flex items-center space-x-1">
                  {Array.from({ length: Math.min(5, paginazione.totalPages) }, (_, i) => {
                    const page = i + 1;
                    return (
                      <button
                        key={page}
                        onClick={() => setPaginazione(prev => ({ ...prev, page }))}
                        className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                          paginazione.page === page 
                            ? 'bg-blue-600 text-white' 
                            : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
                        }`}
                      >
                        {page}
                      </button>
                    );
                  })}
                </div>

                <div className="sm:hidden text-sm text-gray-700">
                  Pagina {paginazione.page} di {paginazione.totalPages}
                </div>
                
                <button
                  onClick={() => setPaginazione(prev => ({ ...prev, page: prev.page + 1 }))}
                  disabled={paginazione.page === paginazione.totalPages}
                  className="p-2 rounded-md border border-gray-300 bg-white text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronRightIcon className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[1800px] mx-auto px-4 md:px-6 py-6 sm:py-8">
      {/* Header semplice come pagina clienti */}
      <div className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-800">Gestione Utenti</h1>
          <p className="mt-1 text-sm text-gray-600">
            Gestisci utenti della rete commerciale e amministratori del sistema
          </p>
        </div>
        <button
          onClick={handleCreateUser}
          className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-md flex items-center justify-center transition-colors"
        >
          <PlusIcon className="h-5 w-5 mr-2" />
          <span>Nuovo Utente</span>
        </button>
      </div>

      {/* Widget Stato Licenze per Agenzie */}
      <div className="mb-6">
        <LicenseStatusWidget 
          userRole={user?.role || user?.ruolo} 
          userId={user?.id}
        />
      </div>

      {/* Statistiche semplificate */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <UserGroupIcon className="h-8 w-8 text-blue-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-500">Totale Utenti</p>
              <p className="text-2xl font-semibold text-gray-900">
                {(statistiche?.utentiRete?.totale || 0) + (statistiche?.admin?.totale || 0)}
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <CheckCircleIcon className="h-8 w-8 text-green-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-500">Utenti Attivi</p>
              <p className="text-2xl font-semibold text-gray-900">
                {(statistiche?.utentiRete?.attivi || 0) + (statistiche?.admin?.attivi || 0)}
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <UserGroupIcon className="h-8 w-8 text-blue-500" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-500">Rete Commerciale</p>
              <p className="text-2xl font-semibold text-gray-900">
                {statistiche?.utentiRete?.totale || 0}
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <ShieldCheckIcon className="h-8 w-8 text-purple-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-500">Amministratori</p>
              <p className="text-2xl font-semibold text-gray-900">
                {statistiche?.admin?.totale || 0}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation semplificata */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 mb-6 overflow-hidden">
        <nav className="flex">
          <button
            onClick={() => {
              setActiveTab('rete');
              setPaginazione(prev => ({ ...prev, page: 1 }));
            }}
            className={`flex-1 py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'rete'
                ? 'border-blue-500 text-blue-600 bg-blue-50'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-center space-x-2">
              <UserGroupIcon className="h-5 w-5" />
              <span>Utenti Rete</span>
              <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                {statistiche?.utentiRete?.totale || 0}
              </span>
            </div>
          </button>
          <button
            onClick={() => {
              setActiveTab('admin');
              setPaginazione(prev => ({ ...prev, page: 1 }));
            }}
            className={`flex-1 py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'admin'
                ? 'border-blue-500 text-blue-600 bg-blue-50'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-center space-x-2">
              <ShieldCheckIcon className="h-5 w-5" />
              <span>Amministratori</span>
              <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                {statistiche?.admin?.totale || 0}
              </span>
            </div>
          </button>
        </nav>
      </div>

      {/* Filtri */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="relative">
            <MagnifyingGlassIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
            <input
              type="text"
              placeholder="Cerca utente..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 pl-9 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {activeTab === 'rete' && (
            <div>
              <select
                value={filtroRuolo}
                onChange={(e) => setFiltroRuolo(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value="">Tutti i ruoli</option>
                <option value="agenzia">Agenzia</option>
                <option value="subagente">Subagente</option>
              </select>
            </div>
          )}

          <div>
            <select
              value={filtroAttivo}
              onChange={(e) => setFiltroAttivo(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            >
              <option value="">Tutti gli stati</option>
              <option value="true">Solo attivi</option>
              <option value="false">Solo inattivi</option>
            </select>
          </div>

          <div className="grid grid-cols-1 gap-2">
            {/* Bottone controllo stati - solo per tab rete */}
            {activeTab === 'rete' && (
              <button
                onClick={controllaStatoUtenti}
                disabled={controlloStatiInCorso}
                className="w-full bg-orange-50 hover:bg-orange-100 text-orange-700 font-medium py-2 px-4 rounded transition-colors disabled:opacity-50 border border-orange-200"
              >
                {controlloStatiInCorso ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-700 mr-2"></div>
                    Controllo...
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <CheckCircleIcon className="h-4 w-4 mr-2" />
                    Controlla Stati
                  </div>
                )}
              </button>
            )}
            
            <button
              onClick={() => {
                setSearchTerm('');
                setFiltroRuolo('');
                setFiltroAttivo('');
              }}
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2 px-4 rounded transition-colors"
            >
              Pulisci filtri
            </button>
          </div>
        </div>
      </div>

      {/* Tabella */}
      <TabellaUtenti />

      {/* Modal Creazione/Modifica Utente Rete */}
      {showUserModal && (
        <ModalUtenteRete
          mode={modalMode}
          utente={selectedUser}
          onClose={() => {
            setShowUserModal(false);
            setSelectedUser(null);
            setModalMode('create');
          }}
          onSave={handleSaveUtenteRete}
          ruoliDisponibili={ruoliDisponibili}
        />
      )}

      {/* Modal Creazione/Modifica Admin */}
      {showAdminModal && (
        <ModalAdmin
          mode={modalMode}
          admin={selectedUser}
          onClose={() => {
            setShowAdminModal(false);
            setSelectedUser(null);
            setModalMode('create');
          }}
          onSave={handleSaveAdmin}
        />
      )}

      {/* Modal Reset Password */}
      {showPasswordModal && selectedUser && (
        <ModalResetPassword
          utente={selectedUser}
          tipoUtente={activeTab}
          onClose={() => {
            setShowPasswordModal(false);
            setSelectedUser(null);
          }}
          onSave={handleResetPasswordAction}
        />
      )}

      {/* Modal Conferma Eliminazione */}
      {showDeleteModal && selectedUser && (
        <ModalConfermaEliminazione
          utente={selectedUser}
          tipoUtente={activeTab}
          onClose={() => {
            setShowDeleteModal(false);
            setSelectedUser(null);
          }}
          onConfirm={handleDeleteUtente}
        />
      )}
    </div>
  );
};

// Component Modal per Utenti Rete
const ModalUtenteRete = ({ mode, utente, onClose, onSave, ruoliDisponibili }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    nome: '',
    cognome: '',
    telefono: '',
    role: 'subagente',
    // Dati nodo rete opzionali
    creaNodoRete: false,
    nodoRete: {
      gruppoId: 1,
      tipoNodo: 'agente',
      nome: '',
      parentId: null,
      descrizione: '',
      provvigioneTipo: 'percentuale',
      provvigioneValore: 0
    },
    // Dati anagrafica aziendale
    anagrafica: {
      ragioneSociale: '',
      indirizzo: '',
      citta: '',
      provincia: '',
      cap: '',
      // Dati fatturazione
      fatturazioneIndirizzo: '',
      fatturazioneCap: '',
      fatturazioneCitta: '',
      fatturazioneProvincia: '',
      pec: '',
      codiceSdi: '',
      codiceFiscale: '',
      partitaIva: '',
      iban: ''
    }
  });
  
  const [loading, setLoading] = useState(false);
  const [errori, setErrori] = useState({});
  const [gruppiDisponibili, setGruppiDisponibili] = useState([]);
  
  // Stati per autocompletamento geografico
  const [showProvinciaDropdown, setShowProvinciaDropdown] = useState(false);
  const [showCittaDropdown, setShowCittaDropdown] = useState(false);
  const [provinciaSearch, setProvinciaSearch] = useState('');
  const [cittaSearch, setCittaSearch] = useState('');
  const [availableComuni, setAvailableComuni] = useState([]);
  const [filteredComuni, setFilteredComuni] = useState([]);
  const [loadingComuni, setLoadingComuni] = useState(false);
  
  // Stati per autocompletamento geografico fatturazione
  const [showProvinciaFattDropdown, setShowProvinciaFattDropdown] = useState(false);
  const [showCittaFattDropdown, setShowCittaFattDropdown] = useState(false);
  const [provinciaFattSearch, setProvinciaFattSearch] = useState('');
  const [cittaFattSearch, setCittaFattSearch] = useState('');
  const [availableComuniFatt, setAvailableComuniFatt] = useState([]);
  const [filteredComuniFatt, setFilteredComuniFatt] = useState([]);
  const [loadingComuniFatt, setLoadingComuniFatt] = useState(false);

  // Stati per ricerca azienda
  const [showCompanySearch, setShowCompanySearch] = useState(false);
  const [companySearchTerm, setCompanySearchTerm] = useState('');
  const [companySearchResults, setCompanySearchResults] = useState([]);
  const [loadingCompanySearch, setLoadingCompanySearch] = useState(false);

  // Funzioni per autocompletamento geografico
  const filteredProvince = PROVINCE_ITALIANE.filter(provincia => 
    provincia.nome.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.sigla.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.regione.toLowerCase().includes(provinciaSearch.toLowerCase())
  );

  const selectedProvincia = PROVINCE_ITALIANE.find(p => p.sigla === formData.anagrafica.provincia);
  const provinciaDisplayText = selectedProvincia 
    ? `${selectedProvincia.nome} (${selectedProvincia.sigla}) - ${selectedProvincia.regione}`
    : '';

  const filteredProvinceFatt = PROVINCE_ITALIANE.filter(provincia => 
    provincia.nome.toLowerCase().includes(provinciaFattSearch.toLowerCase()) ||
    provincia.sigla.toLowerCase().includes(provinciaFattSearch.toLowerCase()) ||
    provincia.regione.toLowerCase().includes(provinciaFattSearch.toLowerCase())
  );

  const selectedProvinciaFatt = PROVINCE_ITALIANE.find(p => p.sigla === formData.anagrafica.fatturazioneProvincia);
  const provinciaFattDisplayText = selectedProvinciaFatt 
    ? `${selectedProvinciaFatt.nome} (${selectedProvinciaFatt.sigla}) - ${selectedProvinciaFatt.regione}`
    : '';

  // Gestori per selezione provincia/città
  const handleSelectProvincia = (provincia) => {
    setFormData(prev => ({
      ...prev,
      anagrafica: {
        ...prev.anagrafica,
        provincia: provincia.sigla,
        citta: '', // Reset della città quando cambia provincia
        cap: '' // Reset del CAP quando cambia provincia
      }
    }));
    setShowProvinciaDropdown(false);
    setProvinciaSearch('');
  };

  const handleSelectCitta = (comune) => {
    setFormData(prev => ({
      ...prev,
      anagrafica: {
        ...prev.anagrafica,
        citta: comune.nome,
        cap: comune.cap || prev.anagrafica.cap // Imposta il CAP se disponibile
      }
    }));
    setShowCittaDropdown(false);
    setCittaSearch('');
  };

  const handleSelectProvinciaFatt = (provincia) => {
    setFormData(prev => ({
      ...prev,
      anagrafica: {
        ...prev.anagrafica,
        fatturazioneProvincia: provincia.sigla,
        fatturazioneCitta: '', // Reset della città quando cambia provincia
        fatturazioneCap: '' // Reset del CAP quando cambia provincia
      }
    }));
    setShowProvinciaFattDropdown(false);
    setProvinciaFattSearch('');
  };

  const handleSelectCittaFatt = (comune) => {
    setFormData(prev => ({
      ...prev,
      anagrafica: {
        ...prev.anagrafica,
        fatturazioneCitta: comune.nome,
        fatturazioneCap: comune.cap || prev.anagrafica.fatturazioneCap // Imposta il CAP se disponibile
      }
    }));
    setShowCittaFattDropdown(false);
    setCittaFattSearch('');
  };

  // Funzione per verificare P.IVA tramite API VIES ufficiale
  const searchCompanies = async (term) => {
    if (term.length < 11) { // Richiede P.IVA completa (11 cifre)
      setCompanySearchResults([]);
      return;
    }

    // Verifica che sia una P.IVA italiana valida (11 cifre)
    const cleanTerm = term.replace(/\s/g, '');
    const isPartitaIva = /^\d{11}$/.test(cleanTerm);
    
    if (!isPartitaIva) {
      setCompanySearchResults([{
        ragioneSociale: '⚠️ Inserisci una Partita IVA italiana valida (11 cifre)',
        partitaIva: '',
        isError: true
      }]);
      return;
    }

    setLoadingCompanySearch(true);
    try {
      console.log(`🔍 Verifica P.IVA: ${cleanTerm} tramite proxy VIES`);
      
      // Usa il proxy backend per evitare errori CORS
      const response = await api.get(`/vies/verifica-piva/${cleanTerm}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        timeout: 15000 // 15 secondi di timeout
      });
      
      console.log('📊 Risposta proxy VIES:', response.data);
      
      if (response.data.success && response.data.data) {
        const azienda = {
          ragioneSociale: response.data.data.ragioneSociale,
          codiceFiscale: response.data.data.codiceFiscale,
          partitaIva: response.data.data.partitaIva,
          indirizzo: response.data.data.indirizzo,
          citta: '',
          provincia: '',
          cap: '',
          pec: '',
          telefono: '',
          fonte: 'VIES - Commissione Europea',
          isVerified: true,
          requestDate: response.data.data.requestDate
        };
        
        setCompanySearchResults([azienda]);
        console.log('✅ Azienda verificata:', azienda.ragioneSociale);
      } else {
        setCompanySearchResults([{
          ragioneSociale: '❌ Partita IVA non valida o azienda non attiva',
          partitaIva: cleanTerm,
          isError: true,
          errorMessage: 'La P.IVA potrebbe essere cessata o non esistere'
        }]);
        console.log('❌ P.IVA non valida:', cleanTerm);
      }
      
    } catch (apiError) {
      console.error('❌ Errore verifica P.IVA:', apiError);
      
      let errorMessage = 'Servizio temporaneamente non disponibile. Riprova più tardi.';
      
      if (apiError.response) {
        // Errori dal backend viesapi.eu
        switch (apiError.response.status) {
          case 400:
            errorMessage = 'Formato P.IVA non valido';
            break;
          case 401:
            errorMessage = 'Errore di autenticazione API';
            break;
          case 404:
            errorMessage = 'Partita IVA non registrata nel sistema VIES';
            break;
          case 408:
            errorMessage = 'Timeout nella verifica. Riprova più tardi.';
            break;
          case 429:
            errorMessage = 'Limite verifiche raggiunto. Riprova più tardi.';
            break;
          case 503:
            errorMessage = 'Servizio VIES temporaneamente non disponibile';
            break;
          default:
            errorMessage = apiError.response.data?.details || 'Errore del servizio di verifica';
        }
      }
      
      setCompanySearchResults([{
        ragioneSociale: '🌐 Errore nella verifica P.IVA',
        partitaIva: cleanTerm,
        isError: true,
        errorMessage
      }]);
    } finally {
      setLoadingCompanySearch(false);
    }
  };

  // Gestisce la selezione di un'azienda
  const handleSelectCompany = (azienda) => {
    // Non permettere selezione di messaggi di errore
    if (azienda.isError) {
      return;
    }

    setFormData(prev => ({
      ...prev,
      anagrafica: {
        ...prev.anagrafica,
        ragioneSociale: azienda.ragioneSociale,
        codiceFiscale: azienda.codiceFiscale,
        partitaIva: azienda.partitaIva,
        indirizzo: azienda.indirizzo,
        citta: azienda.citta,
        provincia: azienda.provincia,
        cap: azienda.cap,
        pec: azienda.pec,
        // Copia anche sui dati di fatturazione se vuoti
        fatturazioneIndirizzo: prev.anagrafica.fatturazioneIndirizzo || azienda.indirizzo,
        fatturazioneCitta: prev.anagrafica.fatturazioneCitta || azienda.citta,
        fatturazioneProvincia: prev.anagrafica.fatturazioneProvincia || azienda.provincia,
        fatturazioneCap: prev.anagrafica.fatturazioneCap || azienda.cap
      }
    }));
    
    // Aggiorna anche il telefono se vuoto
    if (!formData.telefono && azienda.telefono) {
      setFormData(prev => ({
        ...prev,
        telefono: azienda.telefono
      }));
    }
    
    setShowCompanySearch(false);
    setCompanySearchTerm('');
    
    if (azienda.isVerified) {
      toast.success('🇪🇺 Partita IVA verificata tramite sistema VIES ufficiale');
    } else {
      toast.success('Dati azienda caricati');
    }
  };

  // Debounce per la ricerca azienda
  useEffect(() => {
    if (companySearchTerm.length >= 3) {
      const debounceTimer = setTimeout(() => searchCompanies(companySearchTerm), 500);
      return () => clearTimeout(debounceTimer);
    } else {
      setCompanySearchResults([]);
    }
  }, [companySearchTerm]);

  useEffect(() => {
    if ((mode === 'edit' || mode === 'view') && utente) {
      setFormData({
        username: utente.username || '',
        email: utente.email || '',
        password: '', // Non mostrare mai la password
        nome: utente.nome || '',
        cognome: utente.cognome || '',
        telefono: utente.telefono || '',
        role: utente.role || 'subagente',
        creaNodoRete: !!utente.nodoRete,
        nodoRete: {
          gruppoId: utente.nodoRete?.gruppoId || 1,
          tipoNodo: utente.nodoRete?.tipoNodo || 'agente',
          nome: utente.nodoRete?.nome || '',
          parentId: utente.nodoRete?.parentId || null,
          descrizione: utente.nodoRete?.descrizione || '',
          provvigioneTipo: utente.nodoRete?.provvigioneTipo || 'percentuale',
          provvigioneValore: utente.nodoRete?.provvigioneValore || 0
        },
        anagrafica: {
          ragioneSociale: utente.anagrafica?.ragioneSociale || '',
          indirizzo: utente.anagrafica?.indirizzo || '',
          citta: utente.anagrafica?.citta || '',
          provincia: utente.anagrafica?.provincia || '',
          cap: utente.anagrafica?.cap || '',
          fatturazioneIndirizzo: utente.anagrafica?.fatturazioneIndirizzo || '',
          fatturazioneCap: utente.anagrafica?.fatturazioneCap || '',
          fatturazioneCitta: utente.anagrafica?.fatturazioneCitta || '',
          fatturazioneProvincia: utente.anagrafica?.fatturazioneProvincia || '',
          pec: utente.anagrafica?.pec || '',
          codiceSdi: utente.anagrafica?.codiceSdi || '',
          codiceFiscale: utente.anagrafica?.codiceFiscale || '',
          partitaIva: utente.anagrafica?.partitaIva || '',
          iban: utente.anagrafica?.iban || ''
        }
      });
    }
    
    // Carica gruppi disponibili solo se necessario (nodo rete attivo e non in modalità view)
    if (mode !== 'view' && (mode === 'create' || (utente && utente.nodoRete))) {
      caricaGruppi();
    }
  }, [mode, utente]);

  // Carica i comuni quando cambia la provincia
  useEffect(() => {
    const loadComuni = async () => {
      if (formData.anagrafica.provincia) {
        setLoadingComuni(true);
        try {
          const comuni = await getComuniByProvincia(formData.anagrafica.provincia);
          setAvailableComuni(comuni);
          setFilteredComuni(comuni);
        } catch (error) {
          console.error('Errore nel caricamento comuni:', error);
          setAvailableComuni(getDefaultComuni());
          setFilteredComuni(getDefaultComuni());
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setAvailableComuni(getDefaultComuni());
        setFilteredComuni(getDefaultComuni());
      }
    };
    
    loadComuni();
  }, [formData.anagrafica.provincia]);

  // Carica i comuni fatturazione quando cambia la provincia fatturazione
  useEffect(() => {
    const loadComuniFatt = async () => {
      if (formData.anagrafica.fatturazioneProvincia) {
        setLoadingComuniFatt(true);
        try {
          const comuni = await getComuniByProvincia(formData.anagrafica.fatturazioneProvincia);
          setAvailableComuniFatt(comuni);
          setFilteredComuniFatt(comuni);
        } catch (error) {
          console.error('Errore nel caricamento comuni fatturazione:', error);
          setAvailableComuniFatt(getDefaultComuni());
          setFilteredComuniFatt(getDefaultComuni());
        } finally {
          setLoadingComuniFatt(false);
        }
      } else {
        setAvailableComuniFatt(getDefaultComuni());
        setFilteredComuniFatt(getDefaultComuni());
      }
    };
    
    loadComuniFatt();
  }, [formData.anagrafica.fatturazioneProvincia]);

  // Filtra i comuni in base alla ricerca
  useEffect(() => {
    const filterComuni = async () => {
      if (cittaSearch.length >= 2 && formData.anagrafica.provincia) {
        setLoadingComuni(true);
        try {
          const risultati = await searchComuni(cittaSearch, formData.anagrafica.provincia);
          setFilteredComuni(risultati);
        } catch (error) {
          console.error('Errore nella ricerca comuni:', error);
          setFilteredComuni([]);
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setFilteredComuni(availableComuni);
      }
    };
    
    const debounceTimer = setTimeout(filterComuni, 300);
    return () => clearTimeout(debounceTimer);
  }, [cittaSearch, availableComuni, formData.anagrafica.provincia]);

  // Filtra i comuni fatturazione in base alla ricerca
  useEffect(() => {
    const filterComuniFatt = async () => {
      if (cittaFattSearch.length >= 2 && formData.anagrafica.fatturazioneProvincia) {
        setLoadingComuniFatt(true);
        try {
          const risultati = await searchComuni(cittaFattSearch, formData.anagrafica.fatturazioneProvincia);
          setFilteredComuniFatt(risultati);
        } catch (error) {
          console.error('Errore nella ricerca comuni fatturazione:', error);
          setFilteredComuniFatt([]);
        } finally {
          setLoadingComuniFatt(false);
        }
      } else {
        setFilteredComuniFatt(availableComuniFatt);
      }
    };
    
    const debounceTimer = setTimeout(filterComuniFatt, 300);
    return () => clearTimeout(debounceTimer);
  }, [cittaFattSearch, availableComuniFatt, formData.anagrafica.fatturazioneProvincia]);

  // Chiudi dropdown quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('[data-dropdown]') && !event.target.closest('input')) {
        setShowProvinciaDropdown(false);
        setShowCittaDropdown(false);
        setShowProvinciaFattDropdown(false);
        setShowCittaFattDropdown(false);
        setShowCompanySearch(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const caricaGruppi = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/network/gruppi?attivo=true&limit=100', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setGruppiDisponibili(data.data?.gruppi || []);
      }
    } catch (error) {
      console.error('Errore nel caricamento gruppi:', error);
    }
  };

  const validaForm = () => {
    const nuoviErrori = {};
    
    if (!formData.username.trim()) nuoviErrori.username = 'Username richiesto';
    if (!formData.email.trim()) nuoviErrori.email = 'Email richiesta';
    if (mode === 'create' && !formData.password.trim()) nuoviErrori.password = 'Password richiesta';
    if (!formData.nome.trim()) nuoviErrori.nome = 'Nome richiesto';
    if (!formData.cognome.trim()) nuoviErrori.cognome = 'Cognome richiesto';
    
    if (formData.creaNodoRete) {
      if (!formData.nodoRete.tipoNodo) nuoviErrori.tipoNodo = 'Tipo nodo richiesto';
      if (formData.nodoRete.tipoNodo === 'agenzia_primaria' && !formData.nodoRete.nome.trim()) {
        nuoviErrori.nomeNodo = 'Nome nodo richiesto per Agenzia Primaria';
      }
    }
    
    setErrori(nuoviErrori);
    return Object.keys(nuoviErrori).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validaForm()) return;
    
    setLoading(true);
    
    try {
      const datiSalvataggio = {
        username: formData.username.trim(),
        email: formData.email.trim(),
        nome: formData.nome.trim(),
        cognome: formData.cognome.trim(),
        telefono: formData.telefono.trim(),
        role: formData.role
      };
      
      // Solo in creazione inviamo la password
      if (mode === 'create' && formData.password) {
        datiSalvataggio.password = formData.password;
      }
      
      // Aggiungi dati nodo se richiesto
      if (formData.creaNodoRete) {
        datiSalvataggio.nodoRete = {
          ...formData.nodoRete,
          nome: formData.nodoRete.nome || `${formData.nome} ${formData.cognome}`.trim()
        };
      }
      
      // Aggiungi dati anagrafica se presenti
      const anagraficaValida = Object.values(formData.anagrafica).some(value => value && value.trim());
      if (anagraficaValida) {
        datiSalvataggio.anagrafica = formData.anagrafica;
      }
      
      await onSave(datiSalvataggio);
    } catch (error) {
      console.error('Errore nel salvataggio:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        
        {/* Modal */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          {/* Header */}
          <div className="bg-white px-4 pt-4 pb-4 sm:p-6 sm:pb-4 border-b">
            <div className="flex justify-between items-center">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                {mode === 'create' ? 'Nuovo Utente Rete' : 
                 mode === 'edit' ? 'Modifica Utente Rete' : 'Dettagli Utente Rete'}
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
          </div>

          
          {/* Body */}
          <form onSubmit={handleSubmit} className="bg-white px-4 pb-4 sm:p-6 sm:pb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Dati Base Utente */}
              <div className="md:col-span-2">
                <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center border-b border-gray-200 pb-2">
                  <UserIcon className="h-5 w-5 mr-2 text-blue-600" />
                  Informazioni Personali
                </h4>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Username *
                </label>
                <input
                  type="text"
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.username ? 'border-red-300 bg-red-50' : 'border-gray-300 focus:bg-white'}`}
                                          placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.username && <p className="text-red-500 text-xs mt-1 flex items-center"><ExclamationTriangleIcon className="h-3 w-3 mr-1" />{errori.username}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.email ? 'border-red-300 bg-red-50' : 'border-gray-300 focus:bg-white'}`}
                                          placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.email && <p className="text-red-500 text-xs mt-1 flex items-center"><ExclamationTriangleIcon className="h-3 w-3 mr-1" />{errori.email}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome *
                </label>
                <input
                  type="text"
                  value={formData.nome}
                  onChange={(e) => setFormData({...formData, nome: e.target.value})}
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.nome ? 'border-red-300 bg-red-50' : 'border-gray-300 focus:bg-white'}`}
                                          placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.nome && <p className="text-red-500 text-xs mt-1 flex items-center"><ExclamationTriangleIcon className="h-3 w-3 mr-1" />{errori.nome}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cognome *
                </label>
                <input
                  type="text"
                  value={formData.cognome}
                  onChange={(e) => setFormData({...formData, cognome: e.target.value})}
                  className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.cognome ? 'border-red-300 bg-red-50' : 'border-gray-300 focus:bg-white'}`}
                                          placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.cognome && <p className="text-red-500 text-xs mt-1 flex items-center"><ExclamationTriangleIcon className="h-3 w-3 mr-1" />{errori.cognome}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Telefono
                </label>
                <input
                  type="tel"
                  value={formData.telefono}
                  onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                  placeholder=""
                  disabled={mode === 'view'}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ruolo *
                </label>
                <select
                  value={formData.role}
                  onChange={(e) => setFormData({...formData, role: e.target.value})}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                  disabled={mode === 'view'}
                  required
                >
                  <option value="subagente">👨‍💼 Subagente</option>
                  <option value="agenzia">🏢 Agenzia</option>
                  <option value="team_leader">👨‍💻 Team Leader</option>
                  <option value="segnalatore">📍 Segnalatore</option>
                </select>
              </div>

              {mode === 'create' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Password *
                  </label>
                  <input
                    type="password"
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    className={`w-full border rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.password ? 'border-red-300 bg-red-50' : 'border-gray-300 focus:bg-white'}`}
                    placeholder=""
                    required
                  />
                  {errori.password && <p className="text-red-500 text-xs mt-1 flex items-center"><ExclamationTriangleIcon className="h-3 w-3 mr-1" />{errori.password}</p>}
                </div>
              )}
            </div>

            {/* Sezione Anagrafica Aziendale */}
            <div className="border-t border-gray-200 pt-6">
              <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center border-b border-gray-200 pb-2">
                <span className="mr-2">🏢</span>
                Anagrafica Aziendale
              </h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Informazioni Generali */}
                <div className="md:col-span-2">
                  <h5 className="text-md font-semibold text-gray-800 mb-3 flex items-center">
                    <span className="mr-2">📋</span>
                    Informazioni Generali
                  </h5>
                </div>
                
                <div className="relative">
                  <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                    <span className="mr-2">🏢</span>
                    Ragione Sociale
                    <span className="ml-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                      🇪🇺 VIES UE
                    </span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={companySearchTerm || formData.anagrafica.ragioneSociale}
                      onChange={(e) => {
                        setCompanySearchTerm(e.target.value);
                        if (!e.target.value) {
                          setFormData({
                            ...formData,
                            anagrafica: {...formData.anagrafica, ragioneSociale: ''}
                          });
                        }
                      }}
                      onFocus={() => mode !== 'view' && setShowCompanySearch(true)}
                      placeholder="Inserisci Partita IVA (11 cifre) per ricerca automatica..."
                      className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                      disabled={mode === 'view'}
                    />
                    {showCompanySearch && mode !== 'view' && (
                      <div data-dropdown className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                        {loadingCompanySearch ? (
                          <div className="px-4 py-2 text-gray-500 text-sm flex items-center">
                            <span className="animate-spin h-4 w-4 mr-2 border-b-2 border-blue-500 rounded-full"></span>
                            Ricerca aziende...
                          </div>
                        ) : companySearchResults.length > 0 ? (
                          companySearchResults.map((azienda, index) => (
                            <div 
                              key={index}
                              className={`px-4 py-3 border-b border-gray-100 last:border-b-0 transition-colors ${
                                azienda.isError 
                                  ? 'bg-red-50 cursor-default' 
                                  : 'hover:bg-blue-50 cursor-pointer'
                              }`}
                              onClick={() => handleSelectCompany(azienda)}
                            >
                              <div className="flex items-start justify-between">
                                <div className="flex-1">
                                  <div className={`font-medium ${
                                    azienda.isError ? 'text-red-700' : 'text-gray-900'
                                  }`}>
                                    {azienda.ragioneSociale}
                                  </div>
                                  {!azienda.isError && azienda.partitaIva && (
                                    <div className="text-sm text-gray-500 mt-1">
                                      P.IVA: {azienda.partitaIva}
                                      {azienda.citta && ` • ${azienda.citta}`}
                                      {azienda.provincia && ` (${azienda.provincia})`}
                                    </div>
                                  )}
                                  {azienda.errorMessage && (
                                    <div className="text-xs text-red-600 mt-1">
                                      {azienda.errorMessage}
                                    </div>
                                  )}
                                  {!azienda.isError && (
                                    <div className="text-xs text-blue-600 mt-1">
                                      ✅ Clicca per compilare automaticamente tutti i campi
                                    </div>
                                  )}
                                </div>
                                {!azienda.isError && (
                                  <div className="flex-shrink-0 ml-2">
                                    <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800">
                                      🇪🇺 {azienda.fonte}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        ) : companySearchTerm.length >= 3 ? (
                          <div className="px-4 py-2 text-gray-500 text-sm">
                            Nessuna azienda trovata
                          </div>
                        ) : (
                          <div className="px-4 py-2 text-gray-500 text-sm">
                            Digita almeno 3 caratteri per cercare
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>



                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                    <MapPinIcon className="h-4 w-4 mr-2 text-gray-500" />
                    Indirizzo
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.indirizzo}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, indirizzo: e.target.value}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder="Via, numero civico, interno..."
                    disabled={mode === 'view'}
                  />
                </div>

                {/* Campi geografici sulla stessa riga: Provincia, Città, CAP */}
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-12 gap-4">
                  {/* Provincia - 5 colonne */}
                  <div className="md:col-span-5 relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Provincia
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        value={provinciaDisplayText}
                        readOnly
                        placeholder="Seleziona una provincia"
                        className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white cursor-pointer"
                        onClick={() => mode !== 'view' && setShowProvinciaDropdown(!showProvinciaDropdown)}
                        disabled={mode === 'view'}
                      />
                      {showProvinciaDropdown && mode !== 'view' && (
                        <div data-dropdown className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                          <div className="p-2 border-b">
                            <input
                              type="text"
                              placeholder="Cerca provincia, sigla o regione..."
                              value={provinciaSearch}
                              onChange={(e) => setProvinciaSearch(e.target.value)}
                              className="w-full p-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          {filteredProvince.map(provincia => (
                            <div 
                              key={provincia.codice}
                              className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                              onClick={() => handleSelectProvincia(provincia)}
                            >
                              <div className="font-medium">{provincia.nome} ({provincia.sigla})</div>
                              <div className="text-sm text-gray-500">{provincia.regione}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Città - 5 colonne */}
                  <div className="md:col-span-5 relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Città
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        value={cittaSearch || formData.anagrafica.citta}
                        onChange={(e) => {
                          setCittaSearch(e.target.value);
                          if (!e.target.value) {
                            setFormData({
                              ...formData,
                              anagrafica: {...formData.anagrafica, citta: '', cap: ''}
                            });
                          }
                        }}
                        onFocus={() => mode !== 'view' && setShowCittaDropdown(true)}
                        placeholder={formData.anagrafica.provincia ? "Cerca o seleziona città..." : "Seleziona prima una provincia"}
                        className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                        disabled={!formData.anagrafica.provincia || mode === 'view'}
                      />
                      {showCittaDropdown && formData.anagrafica.provincia && mode !== 'view' && (
                        <div data-dropdown className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                          {loadingComuni ? (
                            <div className="px-4 py-2 text-gray-500 text-sm flex items-center">
                              <span className="animate-spin h-4 w-4 mr-2 border-b-2 border-blue-500 rounded-full"></span>
                              Caricamento comuni...
                            </div>
                          ) : filteredComuni.length > 0 ? (
                            filteredComuni.map((comune, index) => (
                              <div 
                                key={`${comune.nome}-${index}`}
                                className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                                onClick={() => handleSelectCitta(comune)}
                              >
                                <div className="font-medium">{comune.nome}</div>
                                {comune.cap && <div className="text-sm text-gray-500">CAP: {comune.cap}</div>}
                              </div>
                            ))
                          ) : (
                            <div className="px-4 py-2 text-gray-500 text-sm">
                              {cittaSearch.length < 2
                                ? 'Digita almeno 2 caratteri per cercare'
                                : 'Nessun comune trovato'
                              }
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* CAP - 2 colonne */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CAP
                    </label>
                    <input
                      type="text"
                      value={formData.anagrafica.cap}
                      onChange={(e) => setFormData({
                        ...formData,
                        anagrafica: {...formData.anagrafica, cap: e.target.value}
                      })}
                      className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                      placeholder="Auto"
                      maxLength="5"
                      disabled={mode === 'view'}
                    />
                  </div>
                </div>

                {/* Dati Fatturazione */}
                <div className="md:col-span-2 mt-6">
                  <div className="flex items-center justify-between mb-3">
                    <h5 className="text-md font-semibold text-gray-800 flex items-center">
                      <span className="mr-2">💰</span>
                      Dati Fatturazione
                    </h5>
                    {mode !== 'view' && (
                      <button
                        type="button"
                        onClick={() => {
                          setFormData(prev => ({
                            ...prev,
                            anagrafica: {
                              ...prev.anagrafica,
                              fatturazioneIndirizzo: prev.anagrafica.indirizzo,
                              fatturazioneCitta: prev.anagrafica.citta,
                              fatturazioneProvincia: prev.anagrafica.provincia,
                              fatturazioneCap: prev.anagrafica.cap
                            }
                          }));
                          toast.success('Dati copiati dall\'indirizzo principale');
                        }}
                        className="text-xs text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-full transition-colors"
                      >
                        📋 Copia da indirizzo principale
                      </button>
                    )}
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Indirizzo Fatturazione
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.fatturazioneIndirizzo}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, fatturazioneIndirizzo: e.target.value}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder="Via, numero civico, interno..."
                    disabled={mode === 'view'}
                  />
                </div>

                {/* Campi geografici fatturazione sulla stessa riga: Provincia, Città, CAP */}
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-12 gap-4">
                  {/* Provincia Fatturazione - 5 colonne */}
                  <div className="md:col-span-5 relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Provincia Fatturazione
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        value={provinciaFattDisplayText}
                        readOnly
                        placeholder="Seleziona una provincia"
                        className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white cursor-pointer"
                        onClick={() => mode !== 'view' && setShowProvinciaFattDropdown(!showProvinciaFattDropdown)}
                        disabled={mode === 'view'}
                      />
                      {showProvinciaFattDropdown && mode !== 'view' && (
                        <div data-dropdown className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                          <div className="p-2 border-b">
                            <input
                              type="text"
                              placeholder="Cerca provincia, sigla o regione..."
                              value={provinciaFattSearch}
                              onChange={(e) => setProvinciaFattSearch(e.target.value)}
                              className="w-full p-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          {filteredProvinceFatt.map(provincia => (
                            <div 
                              key={provincia.codice}
                              className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                              onClick={() => handleSelectProvinciaFatt(provincia)}
                            >
                              <div className="font-medium">{provincia.nome} ({provincia.sigla})</div>
                              <div className="text-sm text-gray-500">{provincia.regione}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Città Fatturazione - 5 colonne */}
                  <div className="md:col-span-5 relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Città Fatturazione
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        value={cittaFattSearch || formData.anagrafica.fatturazioneCitta}
                        onChange={(e) => {
                          setCittaFattSearch(e.target.value);
                          if (!e.target.value) {
                            setFormData({
                              ...formData,
                              anagrafica: {...formData.anagrafica, fatturazioneCitta: '', fatturazioneCap: ''}
                            });
                          }
                        }}
                        onFocus={() => mode !== 'view' && setShowCittaFattDropdown(true)}
                        placeholder={formData.anagrafica.fatturazioneProvincia ? "Cerca o seleziona città..." : "Seleziona prima una provincia"}
                        className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                        disabled={!formData.anagrafica.fatturazioneProvincia || mode === 'view'}
                      />
                      {showCittaFattDropdown && formData.anagrafica.fatturazioneProvincia && mode !== 'view' && (
                        <div data-dropdown className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                          {loadingComuniFatt ? (
                            <div className="px-4 py-2 text-gray-500 text-sm flex items-center">
                              <span className="animate-spin h-4 w-4 mr-2 border-b-2 border-blue-500 rounded-full"></span>
                              Caricamento comuni...
                            </div>
                          ) : filteredComuniFatt.length > 0 ? (
                            filteredComuniFatt.map((comune, index) => (
                              <div 
                                key={`${comune.nome}-${index}`}
                                className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                                onClick={() => handleSelectCittaFatt(comune)}
                              >
                                <div className="font-medium">{comune.nome}</div>
                                {comune.cap && <div className="text-sm text-gray-500">CAP: {comune.cap}</div>}
                              </div>
                            ))
                          ) : (
                            <div className="px-4 py-2 text-gray-500 text-sm">
                              {cittaFattSearch.length < 2
                                ? 'Digita almeno 2 caratteri per cercare'
                                : 'Nessun comune trovato'
                              }
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* CAP Fatturazione - 2 colonne */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CAP Fatturazione
                    </label>
                    <input
                      type="text"
                      value={formData.anagrafica.fatturazioneCap}
                      onChange={(e) => setFormData({
                        ...formData,
                        anagrafica: {...formData.anagrafica, fatturazioneCap: e.target.value}
                      })}
                      className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                      placeholder="Auto"
                      maxLength="5"
                      disabled={mode === 'view'}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    PEC
                  </label>
                  <input
                    type="email"
                    value={formData.anagrafica.pec}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, pec: e.target.value}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder=""
                    disabled={mode === 'view'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Codice SDI
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.codiceSdi}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, codiceSdi: e.target.value.toUpperCase()}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder=""
                    maxLength="7"
                    disabled={mode === 'view'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Codice Fiscale
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.codiceFiscale}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, codiceFiscale: e.target.value.toUpperCase()}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder=""
                    maxLength="16"
                    disabled={mode === 'view'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Partita IVA
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.partitaIva}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, partitaIva: e.target.value}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder=""
                    maxLength="11"
                    disabled={mode === 'view'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    IBAN
                  </label>
                  <input
                    type="text"
                    value={formData.anagrafica.iban}
                    onChange={(e) => setFormData({
                      ...formData,
                      anagrafica: {...formData.anagrafica, iban: e.target.value.toUpperCase()}
                    })}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white"
                    placeholder=""
                    maxLength="27"
                    disabled={mode === 'view'}
                  />
                </div>
              </div>
            </div>

            {/* Sezione Nodo Rete - Solo in creazione */}
            {mode === 'create' && (
              <div className="border-t border-gray-200 pt-6">
                <div className="flex items-center mb-4">
                  <input
                    type="checkbox"
                    id="creaNodoRete"
                    checked={formData.creaNodoRete}
                    onChange={(e) => setFormData({...formData, creaNodoRete: e.target.checked})}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label htmlFor="creaNodoRete" className="ml-3 text-sm font-medium text-gray-700">
                    🌐 Crea anche il nodo nella rete commerciale
                  </label>
                </div>

                {formData.creaNodoRete && (
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 p-6 rounded-xl">
                    <h5 className="text-sm font-semibold text-blue-900 mb-4 flex items-center">
                      <span className="mr-2">⚙️</span>
                      Configurazione Nodo Rete
                    </h5>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Tipo Nodo *
                        </label>
                        <select
                          value={formData.nodoRete.tipoNodo}
                          onChange={(e) => setFormData({
                            ...formData,
                            nodoRete: {...formData.nodoRete, tipoNodo: e.target.value}
                          })}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                          <option value="agente">👨‍💼 Agente</option>
                          <option value="team_leader">👨‍💻 Team Leader</option>
                          <option value="agenzia_primaria">🏢 Agenzia Primaria</option>
                        </select>
                      </div>

                      {formData.nodoRete.tipoNodo === 'agenzia_primaria' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Nome Nodo *
                          </label>
                          <input
                            type="text"
                            value={formData.nodoRete.nome}
                            onChange={(e) => setFormData({
                              ...formData,
                              nodoRete: {...formData.nodoRete, nome: e.target.value}
                            })}
                            className={`w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errori.nomeNodo ? 'border-red-300' : 'border-gray-300'}`}
                            placeholder=""
                          />
                          {errori.nomeNodo && <p className="text-red-500 text-xs mt-1">{errori.nomeNodo}</p>}
                        </div>
                      )}

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Gruppo
                        </label>
                        <select
                          value={formData.nodoRete.gruppoId}
                          onChange={(e) => setFormData({
                            ...formData,
                            nodoRete: {...formData.nodoRete, gruppoId: parseInt(e.target.value)}
                          })}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                          {gruppiDisponibili.map(gruppo => (
                            <option key={gruppo.id} value={gruppo.id}>
                              {gruppo.nome}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Provvigione (%)
                        </label>
                        <input
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          value={formData.nodoRete.provvigioneValore}
                          onChange={(e) => setFormData({
                            ...formData,
                            nodoRete: {...formData.nodoRete, provvigioneValore: parseFloat(e.target.value) || 0}
                          })}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Footer */}
            {mode !== 'view' && (
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
                >
                  {loading && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  )}
                  {mode === 'create' ? 'Crea Utente' : 'Aggiorna Utente'}
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Annulla
                </button>
              </div>
            )}

            {mode === 'view' && (
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={onClose}
                  className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
                >
                  Chiudi
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

// Component Modal per Admin
const ModalAdmin = ({ mode, admin, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    nome: '',
    cognome: '',
    telefono: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [errori, setErrori] = useState({});

  useEffect(() => {
    if (mode === 'edit' && admin) {
      setFormData({
        username: admin.username || '',
        email: admin.email || '',
        password: '', // Non mostrare mai la password
        nome: admin.nome || '',
        cognome: admin.cognome || '',
        telefono: admin.telefono || ''
      });
    }
  }, [mode, admin]);

  const validaForm = () => {
    const nuoviErrori = {};
    
    if (!formData.username.trim()) nuoviErrori.username = 'Username richiesto';
    if (!formData.email.trim()) nuoviErrori.email = 'Email richiesta';
    if (mode === 'create' && !formData.password.trim()) nuoviErrori.password = 'Password richiesta';
    if (!formData.nome.trim()) nuoviErrori.nome = 'Nome richiesto';
    if (!formData.cognome.trim()) nuoviErrori.cognome = 'Cognome richiesto';
    
    setErrori(nuoviErrori);
    return Object.keys(nuoviErrori).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validaForm()) return;
    
    setLoading(true);
    
    try {
      const datiSalvataggio = {
        username: formData.username.trim(),
        email: formData.email.trim(),
        nome: formData.nome.trim(),
        cognome: formData.cognome.trim(),
        telefono: formData.telefono.trim()
      };
      
      // Solo in creazione inviamo la password
      if (mode === 'create' && formData.password) {
        datiSalvataggio.password = formData.password;
      }
      
      await onSave(datiSalvataggio);
    } catch (error) {
      console.error('Errore nel salvataggio:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        
        {/* Modal */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
          {/* Header */}
          <div className="bg-white px-4 pt-4 pb-4 sm:p-6 sm:pb-4 border-b">
            <div className="flex justify-between items-center">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                {mode === 'create' ? 'Nuovo Amministratore' : 
                 mode === 'edit' ? 'Modifica Amministratore' : 'Dettagli Amministratore'}
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
          </div>

          
          {/* Body */}
          <form onSubmit={handleSubmit} className="bg-white px-4 pb-4 sm:p-6 sm:pb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Username *
                </label>
                <input
                  type="text"
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  className={`w-full border rounded-lg px-3 py-2 ${errori.username ? 'border-red-300' : 'border-gray-300'}`}
                  placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.username && <p className="text-red-500 text-xs mt-1">{errori.username}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className={`w-full border rounded-lg px-3 py-2 ${errori.email ? 'border-red-300' : 'border-gray-300'}`}
                  placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.email && <p className="text-red-500 text-xs mt-1">{errori.email}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nome *
                </label>
                <input
                  type="text"
                  value={formData.nome}
                  onChange={(e) => setFormData({...formData, nome: e.target.value})}
                  className={`w-full border rounded-lg px-3 py-2 ${errori.nome ? 'border-red-300' : 'border-gray-300'}`}
                  placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.nome && <p className="text-red-500 text-xs mt-1">{errori.nome}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Cognome *
                </label>
                <input
                  type="text"
                  value={formData.cognome}
                  onChange={(e) => setFormData({...formData, cognome: e.target.value})}
                  className={`w-full border rounded-lg px-3 py-2 ${errori.cognome ? 'border-red-300' : 'border-gray-300'}`}
                  placeholder=""
                  disabled={mode === 'view'}
                  required
                />
                {errori.cognome && <p className="text-red-500 text-xs mt-1">{errori.cognome}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Telefono
                </label>
                <input
                  type="tel"
                  value={formData.telefono}
                  onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  placeholder=""
                  disabled={mode === 'view'}
                />
              </div>

              {mode === 'create' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Password *
                  </label>
                  <input
                    type="password"
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    className={`w-full border rounded-lg px-3 py-2 ${errori.password ? 'border-red-300' : 'border-gray-300'}`}
                    placeholder=""
                    required
                  />
                  {errori.password && <p className="text-red-500 text-xs mt-1">{errori.password}</p>}
                </div>
              )}
            </div>

            {/* Footer */}
            {mode !== 'view' && (
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-purple-600 text-base font-medium text-white hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
                >
                  {loading && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  )}
                  {mode === 'create' ? 'Crea Admin' : 'Aggiorna Admin'}
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Annulla
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

// Component Modal Reset Password
const ModalResetPassword = ({ utente, tipoUtente, onClose, onSave }) => {
  const [nuovaPassword, setNuovaPassword] = useState('');
  const [confermaPassword, setConfermaPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!nuovaPassword.trim()) {
      setErrore('La password è obbligatoria');
      return;
    }
    
    if (nuovaPassword !== confermaPassword) {
      setErrore('Le password non coincidono');
      return;
    }
    
    if (nuovaPassword.length < 6) {
      setErrore('La password deve contenere almeno 6 caratteri');
      return;
    }
    
    setLoading(true);
    setErrore('');
    
    try {
      await onSave(utente.id, nuovaPassword);
    } catch (error) {
      console.error('Errore nel reset password:', error);
      setErrore('Errore nel reset della password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 overflow-y-auto h-full w-full z-50">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          {/* Header con Gradiente Giallo */}
          <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white p-6 rounded-t-2xl">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold flex items-center">
                <KeyIcon className="h-6 w-6 mr-3" />
                Reset Password
              </h2>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <p className="text-yellow-100 mt-2 text-sm">
              Imposta una nuova password per l'utente selezionato
            </p>
          </div>

          {/* Info Utente */}
          <div className="p-6">
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 p-4 rounded-xl mb-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                <UserIcon className="h-4 w-4 mr-2 text-gray-600" />
                Dettagli Utente
              </h4>
              <div className="space-y-2 text-sm">
                <p className="text-gray-700">
                  <span className="font-medium">Nome:</span> {utente.nome} {utente.cognome}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Username:</span> {utente.username}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Tipo:</span> {tipoUtente === 'rete' ? '🌐 Utente Rete' : '🛡️ Amministratore'}
                </p>
              </div>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nuova Password *
                </label>
                <input
                  type="password"
                  value={nuovaPassword}
                  onChange={(e) => setNuovaPassword(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-yellow-500 focus:border-transparent focus:bg-white"
                  placeholder=""
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Conferma Password *
                </label>
                <input
                  type="password"
                  value={confermaPassword}
                  onChange={(e) => setConfermaPassword(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 transition-all duration-200 focus:ring-2 focus:ring-yellow-500 focus:border-transparent focus:bg-white"
                  placeholder=""
                  required
                />
              </div>

              {errore && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-xl">
                  <div className="flex items-center">
                    <ExclamationTriangleIcon className="h-5 w-5 text-red-400 mr-2" />
                    <p className="text-red-700 text-sm font-medium">{errore}</p>
                  </div>
                </div>
              )}

              {/* Footer */}
              <div className="flex items-center justify-end pt-4 space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-6 py-3 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-all duration-200 font-medium"
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-8 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-xl hover:from-yellow-600 hover:to-orange-600 transition-all duration-200 flex items-center space-x-2 disabled:opacity-50 font-medium shadow-lg"
                >
                  {loading && (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  )}
                  <KeyIcon className="h-4 w-4" />
                  <span>Reset Password</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

// Component Modal Conferma Eliminazione
const ModalConfermaEliminazione = ({ utente, tipoUtente, onClose, onConfirm }) => {
  const [eliminaDefinitivamente, setEliminaDefinitivamente] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConferma = async () => {
    setLoading(true);
    try {
      await onConfirm(utente.id, eliminaDefinitivamente);
    } catch (error) {
      console.error('Errore nell\'eliminazione:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 overflow-y-auto h-full w-full z-50">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          {/* Header con Gradiente Rosso */}
          <div className="bg-gradient-to-r from-red-500 to-red-600 text-white p-6 rounded-t-2xl">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold flex items-center">
                <ExclamationTriangleIcon className="h-6 w-6 mr-3" />
                Conferma Eliminazione
              </h2>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <p className="text-red-100 mt-2 text-sm">
              Attenzione: questa azione potrebbe essere irreversibile
            </p>
          </div>

          <div className="p-6">
            {/* Info Utente */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 p-4 rounded-xl mb-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                <UserIcon className="h-4 w-4 mr-2 text-gray-600" />
                Dettagli Utente
              </h4>
              <div className="space-y-2 text-sm">
                <p className="text-gray-700">
                  <span className="font-medium">Nome:</span> {utente.nome} {utente.cognome}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Username:</span> {utente.username}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Email:</span> {utente.email}
                </p>
                <p className="text-gray-700">
                  <span className="font-medium">Tipo:</span> {tipoUtente === 'rete' ? '🌐 Utente Rete' : '🛡️ Amministratore'}
                </p>
              </div>
            </div>

            {/* Opzioni */}
            <div className="space-y-4 mb-6">
              <h4 className="font-semibold text-gray-900 mb-3">Seleziona il tipo di operazione:</h4>
              
              <div className="space-y-3">
                <div className="flex items-start p-3 border-2 border-blue-200 rounded-xl bg-blue-50 hover:bg-blue-100 transition-colors cursor-pointer" onClick={() => setEliminaDefinitivamente(false)}>
                  <input
                    type="radio"
                    id="disattiva"
                    name="tipoEliminazione"
                    checked={!eliminaDefinitivamente}
                    onChange={() => setEliminaDefinitivamente(false)}
                    className="h-4 w-4 text-blue-600 border-gray-300 mt-1"
                  />
                  <div className="ml-3">
                    <label htmlFor="disattiva" className="font-medium text-blue-900 cursor-pointer">
                      ✅ Disattiva utente (raccomandato)
                    </label>
                    <p className="text-blue-700 text-sm mt-1">
                      L'utente non potrà accedere ma tutti i dati saranno conservati. Può essere riattivato in futuro.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start p-3 border-2 border-red-200 rounded-xl bg-red-50 hover:bg-red-100 transition-colors cursor-pointer" onClick={() => setEliminaDefinitivamente(true)}>
                  <input
                    type="radio"
                    id="elimina"
                    name="tipoEliminazione"
                    checked={eliminaDefinitivamente}
                    onChange={() => setEliminaDefinitivamente(true)}
                    className="h-4 w-4 text-red-600 border-gray-300 mt-1"
                  />
                  <div className="ml-3">
                    <label htmlFor="elimina" className="font-medium text-red-900 cursor-pointer">
                      ❌ Elimina definitivamente
                    </label>
                    <p className="text-red-700 text-sm mt-1">
                      Rimuove completamente l'utente e tutti i dati associati. Questa azione non può essere annullata.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Warning */}
            <div className={`p-4 border rounded-xl mb-6 ${eliminaDefinitivamente ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200'}`}>
              <div className="flex items-start">
                <ExclamationTriangleIcon className={`h-5 w-5 mt-0.5 ${eliminaDefinitivamente ? 'text-red-500' : 'text-blue-500'}`} />
                <div className="ml-3">
                  <p className={`text-sm font-medium ${eliminaDefinitivamente ? 'text-red-800' : 'text-blue-800'}`}>
                    {eliminaDefinitivamente 
                      ? '⚠️ Attenzione: Eliminazione Definitiva'
                      : 'ℹ️ Informazioni: Disattivazione Utente'
                    }
                  </p>
                  <p className={`text-sm mt-1 ${eliminaDefinitivamente ? 'text-red-700' : 'text-blue-700'}`}>
                    {eliminaDefinitivamente 
                      ? 'L\'eliminazione definitiva rimuoverà completamente l\'utente e tutti i dati associati. Questa azione non può essere annullata.'
                      : 'La disattivazione renderà l\'utente inaccessibile ma manterrà tutti i dati. Può essere riattivato in seguito.'
                    }
                  </p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end space-x-3">
              <button
                onClick={onClose}
                className="px-6 py-3 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-all duration-200 font-medium"
              >
                Annulla
              </button>
              <button
                onClick={handleConferma}
                disabled={loading}
                className={`px-8 py-3 text-white rounded-xl transition-all duration-200 flex items-center space-x-2 disabled:opacity-50 font-medium shadow-lg ${
                  eliminaDefinitivamente
                    ? 'bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800'
                    : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700'
                }`}
              >
                {loading && (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                )}
                {eliminaDefinitivamente ? (
                  <>
                    <TrashIcon className="h-4 w-4" />
                    <span>Elimina Definitivamente</span>
                  </>
                ) : (
                  <>
                    <XCircleIcon className="h-4 w-4" />
                    <span>Disattiva Utente</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



export default GestioneUtentiPage; 